'use strict';

var _jsx = function () { var REACT_ELEMENT_TYPE = typeof Symbol === "function" && Symbol['for'] && Symbol['for']("react.element") || 0xeac7; return function createRawReactElement(type, props, key, children) { var defaultProps = type && type.defaultProps; var childrenLength = arguments.length - 3; if (!props && childrenLength !== 0) { props = {}; } if (props && defaultProps) { for (var propName in defaultProps) { if (props[propName] === void 0) { props[propName] = defaultProps[propName]; } } } else if (!props) { props = defaultProps || {}; } if (childrenLength === 1) { props.children = children; } else if (childrenLength > 1) { var childArray = Array(childrenLength); for (var i = 0; i < childrenLength; i++) { childArray[i] = arguments[i + 3]; } props.children = childArray; } return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: key === undefined ? null : '' + key, ref: null, props: props, _owner: null }; }; }();

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactDom = require('react-dom');

var _reactDom2 = _interopRequireDefault(_reactDom);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { "default": obj }; }

// Tooltip

var _ref = _jsx('span', {
  className: 'm-tooltip--bubble--arrow left'
});

var _ref2 = _jsx('span', {
  className: 'm-tooltip--bubble--arrow top'
});

var _ref3 = _jsx('span', {
  className: 'm-tooltip--bubble--arrow right'
});

var _ref4 = _jsx('span', {
  className: 'm-tooltip--bubble--arrow bottom'
});

var Tooltip = _react2['default'].createClass({
  displayName: 'Tooltip',


  propTypes: {
    'content': _react2['default'].PropTypes.string.isRequired,
    'text': _react2['default'].PropTypes.string,
    'arrowPosition': _react2['default'].PropTypes.string,
    'isToggled': _react2['default'].PropTypes.bool,
    'isToggleable': _react2['default'].PropTypes.bool, // If false, tooltip will always be permanently displayed
    'classes': _react2['default'].PropTypes.string,
    'cta': _react2['default'].PropTypes.object,
    'lockToElement': _react2['default'].PropTypes.string, // Optional element to lock to
    'toggleOn': _react2['default'].PropTypes.string, // Events to toggle on (change/blur/etc) if using the above
    'contentStyle': _react2['default'].PropTypes.object, // Additional styles for tooltip content
    'minWidth': _react2['default'].PropTypes.string
  },

  getDefaultProps: function getDefaultProps() {
    return {
      'text': '?',
      'arrowPosition': 'bottom',
      'isToggled': false,
      'isToggleable': true,
      'lockToElement': null,
      'toggleOn': 'mouseenter mouseleave'
    };
  },

  getInitialState: function getInitialState() {
    return {
      'toggled': this.props.isToggled,
      'isToggleable': this.props.isToggleable
    };
  },
  // TODO: refactor the jQuery out of this
  componentDidMount: function componentDidMount() {
    var self = this;
    var root = $(_reactDom2['default'].findDOMNode(this));

    if (this.state.isToggleable && !this.props.lockToElement) {
      $('.m-tooltip--text', root).bind(this.props.toggleOn, this.toggleTip);
    } else if (this.state.isToggleable) {
      // Using an element to lock to
      $(this.props.lockToElement).bind(this.props.toggleOn, this.toggleTip);
    }
    this.adjustTooltipPosition();
  },

  adjustTooltipPosition: function adjustTooltipPosition() {
    var root = $(_reactDom2['default'].findDOMNode(this));
    var parent = root.parent();
    var isVisible = parent.css('display') !== 'none';
    var tooltipBubbleEl;
    var newTop;
    var newLeft;
    if (!isVisible) {
      // Display the tooltip container so we can correctly size it
      parent.show();
    }

    // Adjust vertical positioning if the tooltip is toggled on
    if (this.state.toggled && !this.props.lockToElement) {
      if ($.inArray(this.props.arrowPosition, ['left', 'right']) >= 0) {
        tooltipBubbleEl = $('.m-tooltip--bubble', root);
        tooltipBubbleEl.css({ 'min-width': this.props.minWidth });
        var currentTop = tooltipBubbleEl.offset().top;
        var offsetParentTop = tooltipBubbleEl.offsetParent().offset().top;
        if (offsetParentTop === 0) {
          newTop = currentTop - tooltipBubbleEl.height() / 2 + 7;
          tooltipBubbleEl.css('top', newTop);
        } else {
          var tooltipTextEl = $('.m-tooltip--text', root);
          var tooltipTextCenter = tooltipTextEl.offset().top + tooltipTextEl.height() / 2;
          var vertAdjustment = tooltipTextCenter - (currentTop + tooltipBubbleEl.height() / 2);
          newTop = currentTop - offsetParentTop + vertAdjustment;
          tooltipBubbleEl.css('top', newTop);
        }
      }
    } else if (this.state.toggled && this.props.lockToElement) {

      // height of box - offset of element
      var lockedElNode = $(this.props.lockToElement);
      var lockedElPosition = lockedElNode.position();
      var lockedElWidth = lockedElNode.outerWidth();
      var lockedElHeight = lockedElNode.innerHeight();
      tooltipBubbleEl = $('.m-tooltip--bubble', root);

      // Currently only used for left arrow positioning vs an element
      if (this.props.arrowPosition == 'left') {
        newLeft = lockedElPosition.left + lockedElWidth;
        tooltipBubbleEl.css({ 'left': newLeft });
        tooltipBubbleEl.css({ 'min-width': this.props.minWidth });
        // Set top value after setting left to account for the new width of the
        // tooltip bubble, since it's auto-width. This puts the vertical center in
        // the correct location
        var lockedElVertMiddle = lockedElPosition.top + lockedElHeight / 2;
        newTop = lockedElVertMiddle - tooltipBubbleEl.innerHeight() / 2;
        tooltipBubbleEl.css({ 'top': newTop });
      } else if (this.props.arrowPosition == 'bottom') {
        newLeft = Math.abs(lockedElPosition.left + lockedElWidth / 2 - tooltipBubbleEl.outerWidth() / 2);
        tooltipBubbleEl.css({ 'left': newLeft });
        newTop = lockedElPosition.top - tooltipBubbleEl.height() - 10;
        tooltipBubbleEl.css({ 'top': newTop });
      }
    }

    if (!isVisible) {
      parent.hide();
    }
  },

  /*
  * Function to toggle tooltip. If using custom events, you can attach a value payload  - 'show' will show the tooltip, anything else will hide
  * This is useful in implementing more complex display logic.
  */

  toggleTip: function toggleTip(e) {

    // Using custom event payload
    if (e && e.value) {
      this.setState({
        'toggled': e.value === 'show'
      });
      // Every other case
    } else {
        this.setState({
          'toggled': !this.state.toggled
        });
      }

    this.adjustTooltipPosition();
  },

  render: function render() {

    var classes = 'm-tooltip';
    if (this.props.classes) {
      classes += ' ' + this.props.classes;
    }

    var cta;
    var ctaClass;
    if (this.props.cta) {
      ctaClass = 'm-tooltip--bubble--content--cta ' + (this.props.cta['class'] || '');
      cta = _jsx('a', {
        href: this.props.cta.url,
        className: ctaClass
      }, void 0, this.props.cta.text);
    }

    var bubble;
    if (!this.state.isToggleable || this.state.isToggleable && this.state.toggled) {
      bubble = _jsx('span', {
        className: 'm-tooltip--bubble ' + this.props.arrowPosition
      }, void 0, _ref, _ref2, _jsx('span', {
        className: 'm-tooltip--bubble--content'
      }, void 0, this.props.content, ' ', cta), _ref3, _ref4);
    }

    var renderText = this.props.lockToElement ? '' : this.props.text;
    return _jsx('span', {
      className: classes
    }, void 0, _jsx('span', {
      className: 'm-tooltip--text'
    }, void 0, renderText), bubble);
  }

});

module.exports = Tooltip;


/*****************
 ** WEBPACK FOOTER
 ** ./src/common/components/tooltip.jsx
 ** module id = 635
 ** module chunks = 0
 **/